// which parts of the app are restricted?
export default [];
